export default __webpack_public_path__ + "static/media/horizon-logo.fafb2b00.png";